__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(542), __webpack_require__.e(444), __webpack_require__.e(525)]).then(() => (() => (__webpack_require__(31542))))));
			register("react-router-dom", "4.3.1", () => (Promise.all([__webpack_require__.e(636), __webpack_require__.e(87), __webpack_require__.e(444), __webpack_require__.e(736)]).then(() => (() => (__webpack_require__(69736))))));
			register("react-router", "4.3.1", () => (Promise.all([__webpack_require__.e(636), __webpack_require__.e(87), __webpack_require__.e(444), __webpack_require__.e(324)]).then(() => (() => (__webpack_require__(83324))))));
			register("react", "16.14.0", () => (__webpack_require__.e(378).then(() => (() => (__webpack_require__(27378))))));
			initExternal(85815);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};